var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-overview',{attrs:{"controller":"Monitor","filter":_vm.Filter,"redirect":"","redirect-page":"Monitors","tab":"monitors","visible":_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }